import { Phone, Mail, MapPin } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_6d3eae7a-9e3d-44ef-92c9-21137f2ed44d/artifacts/dh0tvqgx_Original%20Logo%20Symbol.png";

export const Footer = () => {
  const { settings, services } = useSite();
  const phone = settings?.phone || "514-775-5027";
  const email = settings?.email || "lesentretienselites@gmail.com";

  return (
    <footer className="bg-[#1E3A28] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="Les Entretiens Élites" className="h-10 w-10 rounded" />
              <span className="font-bold text-lg">Les Entretiens Élites</span>
            </div>
            <p className="text-green-200/80 text-sm leading-relaxed">
              Services professionnels d'entretien extérieur à Châteauguay, Mercier, Léry et les environs.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-base mb-4">Nos services</h4>
            <ul className="space-y-1.5 text-sm text-green-200/80">
              {services.slice(0, 7).map((s) => (
                <li key={s.id}>{s.name}</li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-base mb-4">Zones desservies</h4>
            <ul className="space-y-1.5 text-sm text-green-200/80">
              {["Châteauguay", "Mercier", "Léry", "Environs"].map((z) => (
                <li key={z} className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 flex-shrink-0" />{z}</li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-base mb-4">Contactez-nous</h4>
            <div className="space-y-3 text-sm">
              <a href={`tel:${phone.replace(/-/g, "")}`} className="flex items-center gap-2 text-green-200/80 hover:text-white transition-colors" data-testid="footer-phone"><Phone className="w-4 h-4" />{phone}</a>
              <a href={`mailto:${email}`} className="flex items-center gap-2 text-green-200/80 hover:text-white transition-colors" data-testid="footer-email"><Mail className="w-4 h-4" />{email}</a>
              <p className="text-green-200/80 pt-2">Appelez ou textez pour une soumission gratuite!</p>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-green-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-center text-xs text-green-200/60">&copy; {new Date().getFullYear()} Les Entretiens Élites. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};
